import { render, staticRenderFns } from "./questionDetail.vue?vue&type=template&id=2a040771&"
import script from "./questionDetail.vue?vue&type=script&lang=js&"
export * from "./questionDetail.vue?vue&type=script&lang=js&"
import style0 from "./questionDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports